var ContentSearch = (function ($) {
    ContentSearch = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        that.$input = that.$wrapper.find('.js-content-search-input');
        that.$loading = that.$wrapper.find('.js-content-search-loading');
        that.$results = that.$wrapper.find('.js-content-search-results-wrapper');

        // Prepare data for Search
        that.$copied_content_loading = that.$loading.clone().show()

        // CONST
        that.scrollbar_is_needed = options['scrollbar_is_needed'] || false;
        that.controller_url = options['controller_url'] || $.sa.build_url('content/search');
        that.controller_params = options['controller_params']

        // DYNAMIC VARS
        that.timer = null;

        // INIT
        that.init();
    };

    ContentSearch.prototype.init = function () {
        var that = this;

        if (that.scrollbar_is_needed) {
            $.uiScrollbar(that.$results);
        }
        //
        that.initWorker();
    };

    ContentSearch.prototype.clearResults = function () {
        var that = this;

        that.$results.html('');
        that.$results.removeAttr("style"); // fix uiScrollbar bug if results empty
    }

    ContentSearch.prototype.initWorker = function () {
        var that = this;

        that.$input.on('input', function () {
            var query = $.trim(that.$input.val());

            if (!query.length) {
                that.clearResults()
            }

            that.$results.html(that.$copied_content_loading)

            that.timer && clearTimeout(that.timer);
            that.timer = setTimeout(function () {
                if (query.length && query.length >= 3 && query.length <= 256) {
                    $.post(that.controller_url, { q: query, ...that.controller_params }, function (res) {
                        that.$results.html(res);
                    });
                } else {
                    that.clearResults()
                }
            }, 300);
        });

    };

    return ContentSearch;
})($);